<template>
  <div class="bg-white rounded-lg shadow-inner shadow-stone-200 border border-stone-300 min-h-32 relative">
    <div v-if="this.$props.loading" class="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-l sm:border-r">
      <font-awesome-icon class="my-1 h-10 w-10 text-3xl text-stone-500 group-hover:text-gray-600 group-focus:text-gray-600 animate-spin" icon="spinner" size="lg" />
    </div>
    <font-awesome-icon v-if="!this.$props.loading && this.$props.icon" :icon="this.$props.icon" class="absolute top-3 right-3 h-4 w-4 text-stone-300" />
    <div v-if="!this.$props.loading" class="flex flex-col p-6 text-center">
      <dt class="order-2 mt-2 text-xs leading-5 font-medium text-stone-500 capitalize">
        <slot></slot>
      </dt>
      <dd class=" order-1 text-xl lg:text-4xl font-extrabold" :class="textColor">
        {{ this.$props.quantity }}
      </dd>
      <div v-if="variation" class="order-3 mt-1 text-xs font-semibold inline-flex items-center justify-center gap-1" :class="variationIsZero ? 'text-stone-400' : (variation.isGood ? 'text-green-600' : 'text-red-600')">
        <font-awesome-icon v-if="!variationIsZero" :icon="variation.percent >= 0 ? 'arrow-up' : 'arrow-down'" class="h-3 w-3" />
        <span>{{ roundedVariationPercent }}%</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DefaultCardComponent",
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    quantity: {
      default: 0
    },
    textColor: {
      type: String,
      default: "text-bpblue"
    },
    icon: {
      type: String,
      default: null
    },
    variation: {
      type: Object,
      default: null
    }
  },
  computed: {
    roundedVariationPercent() {
      return this.variation ? Math.round(Math.abs(this.variation.percent)) : 0
    },
    variationIsZero() {
      return this.roundedVariationPercent === 0
    }
  }
}
</script>

<style scoped>

</style>